<template>
  <!--票务系统-->
  <article>
    <div class="caption">
      <h2>硬件产品</h2>
      <span>HARDWARE SERVICES</span>
    </div>

    <div class="content">
      为保障票务系统稳定性，在票务系统硬件方面我司经多方比选，选定品质更高、稳定性更强的硬件产品来支持和保障客户项目。
    </div>

    <div class="body">
      <div class="item">
        <img src="@/assets/images/product/hardware/1.png" alt="" srcset="">
        <h4>验票闸机</h4>
        <p>景区用闸机，通过显示屏与身份证识读设备、二维码识读设备、人脸识别设备等的结合，实现各种票种介质的验证入园功能</p>
        <!-- <a href="#">产品展示</a> -->
      </div>
      <div class="item">
        <img src="@/assets/images/product/hardware/2.png" alt="" srcset="">
        <h4>验票一体机</h4>
        <p>优秀的定制能力，通过更多验票设备的集成，实现比闸机更多的票种支持，为外宾、港澳台游客提供实名验证服务</p>
        <!-- <a href="#">产品展示</a> -->
      </div>
      <div class="item">
        <img src="@/assets/images/product/hardware/3.png" alt="" srcset="">
        <h4>手持验票机</h4>
        <p>手持设备外观与智能手机类似，操作系统为安卓操作系统，支持身份证、二维码的识别，操作简单</p>
        <!-- <a href="#">产品展示</a> -->
      </div>
      <div class="item">
        <img src="@/assets/images/product/hardware/4.png" alt="" srcset="">
        <h4>身份证阅读器</h4>
        <p>识别二代身份证快速高效，是提高工作效率的不二之选</p>
        <!-- <a href="#">产品展示</a> -->
      </div>
      <div class="item">
        <img src="@/assets/images/product/hardware/5.png" alt="" srcset="">
        <h4>护照阅读器</h4>
        <p>护照阅读器分为桌面式及嵌入式，可识别国际标准电子护照及港澳台证件，方便港澳台及外宾游客的售票及验票</p>
        <!-- <a href="#">产品展示</a> -->
      </div>
      <div class="item">
        <img src="@/assets/images/product/hardware/6.png" alt="" srcset="">
        <h4>门票打印机</h4>
        <p>工业级打印机，配置简单，故障率低，非常适用于出票量较高的场所</p>
        <!-- <a href="#">产品展示</a> -->
      </div>
      <div class="item">
        <img src="@/assets/images/product/hardware/7.png" alt="" srcset="">
        <h4>人脸识别设备</h4>
        <p>1：N人脸识别能力，业内领先的人脸识别算法，识别速度快，可适应较为复杂的现场环境</p>
        <!-- <a href="#">产品展示</a> -->
      </div>
      <div class="item">
        <img src="@/assets/images/product/hardware/8.png" alt="" srcset="">
        <h4>二维码扫枪</h4>
        <p>解读标准一维条码，二维条码，尤其对屏幕条码有很强的解码能力，适合现场窗口收银使用</p>
        <!-- <a href="#">产品展示</a> -->
      </div>
      <div class="item">
        <img src="@/assets/images/product/hardware/9.png" alt="" srcset="">
        <h4>服务器</h4>
        <p>采用业内知名品牌服务器，采购原厂金牌服务，保障票务系统及数据的安全及稳定性</p>
        <!-- <a href="#">产品展示</a> -->
      </div>
    </div>
  </article>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";

article {
  display: flex;
  flex-direction: column;

  > .caption {
    display: flex;
    flex-direction: column;
    align-items: center;
    > h2 {
      display: inline-block;
      border-bottom: 2px solid #666666;
      padding-bottom: 5px;
      font-size: 24px;
    }

    span {
      font-size: 14px;
      font-weight: lighter;
    }
  }

  > .content {
    margin: 20px 0;
    text-align: center;
    font-size: 14px;
  }

  > .body {
    width: $SIZE_PAGE_WIDTH;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 20px 0;

    > .item {
      width: $SIZE_PAGE_WIDTH / 3;
      // background-color: #666666;

      > img {
        width: 100%;
        // height: 100%;
      }

      > h4 {
        margin: 0.05rem 0.05rem;
        font-size: 24px;
      }

      > p {
        margin: 0 0.05rem 0.1rem 0.05rem;
        text-align: justify;
        font-size: 14px;
      }

      > a {
        text-align: center;
        font-size: 14px;
        border: 1px solid #145982;
        color: #145982;
        padding: 5px 15px;
        text-decoration: none;

        &:hover {
          color: white;
          background-color: #145982;
        }
      }
    }
  }
}
</style>